import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { pages } from '../constants/';

@Injectable({
  providedIn: 'root'
})
export class RutasService {

  private rutas = new BehaviorSubject<Array<string>>(null);
  public currentData = this.rutas.asObservable();

  constructor(
    private router: Router
  ) { }

  public getRutas() {
    this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      let lastPage = events[0].url.toString().replace('/', '');
      const currentPage = events[1].url.toString().replace('/', '');
      if ( !lastPage ) {
        lastPage = pages.home;
      }
      this.rutas.next( [lastPage, currentPage] );
    });
  }
}
